import styled from 'styled-components';

export const InfoBox = styled.div<{ noMargins?: boolean }>`
  margin: 20px 0;
  padding: 20px;
  border: ${({ theme }) => `1px solid ${theme.defaultColors.info}`};
  background: ${({ theme }) => theme.defaultColors.infoBackground};
  border-radius: 4px;
  color: ${({ theme }) => `${theme.defaultColors.fontPrimary}`};
`;

export default InfoBox;
